export type CharacterCount = 2 | 3 | 4;
export const defaultCharactersCount: CharacterCount = 2;

export type GameStyle = 'animal' | 'acrobat';
export const defaultGameStyle: GameStyle = "acrobat";